import apiClient, { safeJson } from '@/api/client';
import { PatchVatPolicyBody, PatchVatPolicyResponse } from './types';

/**
 * @method patch
 * @brief 센터 VAT 정산 정책 변경 (inclusive <-> exclusive)
 */
export const patchCenterVatPolicy = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: PatchVatPolicyBody;
}) => {
    const res = await apiClient.patch(`v1/centers/${centerId}/vat-policy`, {
        json: body,
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as PatchVatPolicyResponse | null,
    };
};
